import React, { useEffect, useRef, useState } from 'react';
import "./contactpage.css"

const ContactPage = () => {

  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (

    <div className='contact-main-container'>
      <div className={`contact-card-container  ${isVisible ? 'fade-in' : ''}`} ref={ref}>


      </div>
    </div>
  )
}

export default ContactPage